/*
 * @Author: mayanxia 
 * @Date: 2023-06-26 16:49:11 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-08-03 14:47:10
 */

<template>
  <a-modal :width="modalWidth" :visible="visible" :title="title" destroyOnClose :confirmLoading="confirmLoading"
    @ok="handleSubmit" @cancel="handleCancel" :cancelText="$t('关闭')" wrapClassName="ant-modal-cust-warp">
    <template>
      <a-card style="" :bordered="true" :title="$t('数据详情')">
        <detail-list>
          <detail-list-item :term="$t('表编号')">{{model.meterid}}</detail-list-item>
          <detail-list-item :term="$t('仪表类型')">{{'wq_device_type'|filterDictTextByCache(model.deviceType)}}</detail-list-item>
          <detail-list-item :term="$t('设备名称')">{{model.deviceName}}</detail-list-item>
          
          <detail-list-item :term="$t('安装位置')">{{model.deviceLocation}}</detail-list-item>
          <detail-list-item :term="$t('IMEI号')">{{model.mtImei}}</detail-list-item>
        </detail-list>
      </a-card>
      <a-row :gutter="8" style="margin-top: 20px">
        <a-col :span="10">
          {{ $t('选择命令') }}
          <a-select v-model="commandKey" style="width: 100%" @change="handleCommandChange" :placeholder="$t('选择命令')">
            <a-select-option v-for="item in originalCommandList" :key="item.key" :value="item.key" :label="$t(item.title)">
              {{ $t(item.title) }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <template v-if="commandKey === 0">
        <a-row :gutter="24" style="margin-top: 20px;height: 30vh">
          <a-col :span="6" style="height: 100%;overflow-y: scroll;overflow-x: hidden;">
            <a-row :gutter="24">
              <a-checkbox-group @change="changeSetParams">
                <a-col :span="24" style="padding: 6px" v-for="item in setParamsList" :key="item.key">
                  <a-checkbox :value="item.key">
                    {{ $t(item.title) }}
                  </a-checkbox>
                </a-col>
              </a-checkbox-group>
            </a-row>

          </a-col>
          <a-col :span="18" style="height: 100%;overflow-y: scroll;overflow-x: hidden;">
            <a-form-model ref="formModel" :model="formModel" :rules="rules" :colon="false">
              <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(0)">
                <template v-if="model.deviceType == 'PM'">
                  <a-col :span="12">
                    <a-form-model-item :label="$t('压力报警上限')" prop="pressAlarmTop" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressAlarmTop" :min="-1" :max="3" :precision="4" :placeholder="$t('压力报警上限')" />
                      <div class="ant-input-number-suffix">MPa</div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item :label="$t('压力报警下限')" prop="pressAlarmLow" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressAlarmLow" :min="-1" :max="3" :precision="4" :placeholder="$t('压力报警下限')" />
                      <div class="ant-input-number-suffix">MPa</div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item :label="$t('压力波动报警值')" prop="pressureFlucThreshold" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressureFlucThreshold" :min="-1" :max="3" :precision="4" :placeholder="$t('压力波动报警值')" />
                      <div class="ant-input-number-suffix">MPa</div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                  <a-form-model-item :label="$t('压力恢复报警差值')" prop="pressureWarnDifference" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.pressureWarnDifference" :min="-1" :max="3" :precision="4" :placeholder="$t('压力恢复报警差值')" />
                    <div class="ant-input-number-suffix">MPa</div>
                  </a-form-model-item>
                </a-col>
                </template>
                <template v-else>
                  <a-col :span="12">
                    <a-form-model-item :label="$t('液位报警上限')" prop="pressAlarmTop" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressAlarmTop" :min="-1" :max="15" :precision="4" :placeholder="$t('液位报警上限')" />
                      <div class="ant-input-number-suffix">m</div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item :label="$t('液位报警下限')" prop="pressAlarmLow" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressAlarmLow" :min="-1" :max="15" :precision="4" :placeholder="$t('液位报警下限')" />
                      <div class="ant-input-number-suffix">m</div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item :label="$t('液位波动报警值')" prop="pressureFlucThreshold" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressureFlucThreshold" :min="-1" :max="15" :precision="4" :placeholder="$t('液位波动报警值')" />
                      <div class="ant-input-number-suffix">m</div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item :label="$t('液位恢复报警差值')" prop="pressureWarnDifference" class="ant-input-number-affix">
                      <a-input-number v-model="formModel.pressureWarnDifference" :min="-1" :max="15" :precision="4" :placeholder="$t('液位恢复报警差值')" />
                      <div class="ant-input-number-suffix">m</div>
                    </a-form-model-item>
                  </a-col>
                </template>
                
              </a-row>
              <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(1)">
                <a-col :span="12">
                  <a-form-model-item :label="$t('温度报警上限')" prop="tempAlarmTop" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.tempAlarmTop" :min="0" :max="70" :precision="4" :placeholder="$t('温度报警上限')" />
                    <div class="ant-input-number-suffix">℃</div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('温度报警下限')" prop="tempAlarmLow" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.tempAlarmLow" :min="0" :max="70" :precision="4" :placeholder="$t('温度报警下限')" />
                    <div class="ant-input-number-suffix">℃</div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('温度波动报警值')" prop="tempFlucThreshold" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.tempFlucThreshold" :min="0" :max="70" :precision="4" :placeholder="$t('温度波动报警值')" />
                    <div class="ant-input-number-suffix">℃</div>
                  </a-form-model-item>
                </a-col>
                
                <a-col :span="12">
                  <a-form-model-item :label="$t('温度恢复报警差值')" prop="tempWarnDifference" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.tempWarnDifference" :min="0" :max="70" :precision="4" :placeholder="$t('温度恢复报警差值')" />
                    <div class="ant-input-number-suffix">℃</div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(2)">
                <a-col :span="12">
                  <a-form-model-item :label="$t('上报时间')" prop="reportTime" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.reportTime" :min="1" :max="1440" :precision="0" :placeholder="$t('上报时间')" />
                    <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('采样时间')" prop="collectTime" class="ant-input-number-affix">
                    <a-input-number v-model="formModel.collectTime" :min="0" :max="65000" :precision="0" :placeholder="$t('采样时间')" />
                    <div class="ant-input-number-suffix">{{ $t('*10秒') }}</div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(3)">
                <a-col :span="12">
                  <a-form-model-item :label="$t('电池电量是否复位')" prop="isResetBattery">
                    <a-switch v-model="formModel.isResetBattery" :checked-children="$t('是')" :un-checked-children="$t('否')" />
                  </a-form-model-item>
                  
                </a-col>
              </a-row>
            </a-form-model>
          </a-col>
        </a-row>
      </template>
      <a-form-model v-else ref="formModel" :model="formModel" :rules="rules" :colon="false">
      </a-form-model>
    </template>
  </a-modal>
</template>
<script>
import i18n from '@/i18n'
import { postAction } from '@/api/manage'
import {isNull,isUndefined,isUndefinedAndNull,isEmptyObject} from '@/utils/validate'
import moment from 'moment'
import { USER_AUTH} from "@/store/mutation-types"
import {paramsToFormData} from '@/utils/util'
import {netTypeObj} from '@/utils/constants/protocolConstant'
import DetailList from '@/components/tools/DetailList'
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
const DetailListItem = DetailList.Item
const originalCommandList = [
        {key: 0, title: i18n.t('终端参数设置')}
    ]
const setParamsList = [
        {key: 0, title: i18n.t('设置压力/液位报警参数')},
        {key: 1, title: i18n.t('设置温度报警')},
        {key: 2, title: i18n.t('设置上报参数')},
        {key: 3, title: i18n.t('电池电量是否复位')},
    ]
export default {
    name: "debugNewCommandModal",
    filters: {
      filterDictTextByCache
    },
    components: {
        DetailList,
        DetailListItem
    },
    data () {
        return {
            originalCommandList,
            netTypeObj,
            commandList: [],
            setParamsList,
            modalWidth:900,
            visible: false,
            formModel: {
                pressAlarmTop: null,
                pressAlarmLow: null,
                pressureFlucThreshold: null,
                pressureWarnDifference: null,
                tempAlarmTop: null,
                tempAlarmLow: null,
                tempFlucThreshold: null,
                tempWarnDifference: null,
                reportTime: null,
                collectTime: null,
                isResetBattery: false
                
            },
            confirmLoading: false,
            model: {},
            rules: {
                
            },
            commandKey: 0,
            setCommandParamsKey: [],
            url: {
                sendCommand: '/jeecg-charge/wq/partPWMeterdataCommand/sendCommand'
            },
        }
    },
    computed: {
        title() {
            return this.$t('命令下发')
        }
    },
    methods: {
        moment,
        filterAuth() {
            let permissionList = [];
            let authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");
            console.log(authList)
            for (let auth of authList) {
                if(auth.type != '2') {
                    permissionList.push(auth);
                }
            }
            if (permissionList === null || permissionList === "" || permissionList === undefined||permissionList.length<=0) {
                this.commandList = []
                return;
            }
            let permissions = [];
            for (let item of permissionList) {
                if(item.type != '2'){
                //update--begin--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU-------
                if(item.action){
                    if(item.action.includes(",")){
                    let split = item.action.split(",")
                    for (let i = 0; i <split.length ; i++) {
                        if(!split[i] ||split[i].length==0){
                            continue;
                        }
                        permissions.push(split[i]);
                    }
                    }else{
                    permissions.push(item.action);
                    }
                }
                //update--end--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU------
                }
            }
            console.log(permissions)
            let cmdList = []
            for(let item of this.originalCommandList) {
                if(permissions.includes('newcommand'+item.key)) {
                    cmdList.push(item)
                }
            }
            this.commandList = cmdList
        },
        edit(record) {
            //this.filterAuth();
            this.visible = true;
            this.model = Object.assign({}, record);
            this.formModel.meterId = record.meterid
        },
        handleSubmit() {
            console.log(this.formModel)
            if(isUndefinedAndNull(this.commandKey)) {
                this.$message.error(this.$t("请先选择命令"))
                return
            }
            this.$refs.formModel.validate(valid => {
                if (valid) {
                    let sendParams = this.setCommandParams();
                    if(isEmptyObject(sendParams)) {
                      this.$message.error(this.$t("请设置参数"))
                      return;
                    }
                    this.confirmLoading = true
                    let params =  {}
                    params.meterId = this.formModel.meterId
                    params.cmd = this.commandKey
                    Object.assign(params, sendParams);
                    this.sendCommand(params)
                }
            })
            
        },
        setCommandParams() {
            let params =  {}
            //params.meterId = '867900043325003'
            //params.meterId = this.formModel.meterId
            //params.cmd = this.commandKey
            if(this.commandKey === 0) {
                // 终端参数设置
                if(this.setCommandParamsKey.includes(0)) {
                    // 设置压力报警信息
                    if(!isUndefinedAndNull(this.formModel.pressAlarmTop)) {
                        params['FH'] = this.formModel.pressAlarmTop
                    }
                    if(!isUndefinedAndNull(this.formModel.pressAlarmLow)) {
                        params['FL'] = this.formModel.pressAlarmLow
                    }
                    if(!isUndefinedAndNull(this.formModel.pressureFlucThreshold)) {
                        params['FF'] = this.formModel.pressureFlucThreshold
                    }
                    if(!isUndefinedAndNull(this.formModel.pressureWarnDifference)) {
                        params['FB'] = this.formModel.pressureWarnDifference
                    }
                }
                if(this.setCommandParamsKey.includes(1)) {
                    // 设置温度报警信息
                    if(!isUndefinedAndNull(this.formModel.tempAlarmTop)) {
                        params['TH'] = this.formModel.tempAlarmTop
                    }
                    if(!isUndefinedAndNull(this.formModel.tempAlarmLow)) {
                        params['TL'] = this.formModel.tempAlarmLow
                    }
                    if(!isUndefinedAndNull(this.formModel.tempFlucThreshold)) {
                        params['TF'] = this.formModel.tempFlucThreshold
                    }
                    if(!isUndefinedAndNull(this.formModel.tempWarnDifference)) {
                        params['TB'] = this.formModel.tempWarnDifference
                    }
                }
                if(this.setCommandParamsKey.includes(2)) {
                    // 设置上报参数
                    if(!isUndefinedAndNull(this.formModel.reportTime)) {
                        params['AT'] = this.formModel.reportTime
                    }
                    if(!isUndefinedAndNull(this.formModel.collectTime)) {
                        params['CT'] = this.formModel.collectTime
                    }
                }
                if(this.setCommandParamsKey.includes(3)) {
                    // 电池电量是否复位
                    if(this.formModel.isResetBattery) {
                        params['BR'] = 1
                    }else{
                      params['BR'] = 0
                    }
                }
            }
            return params
        },
        // 新协议下发命令
        sendCommand(params) {
          console.log(params)
            let formData = paramsToFormData(params)
            postAction(this.url.sendCommand, formData).then((res) => {
                this.confirmLoading = false;
                if (res.success && res.code==0) {
                    this.$message.success(this.$t("命令添加成功"))
                    this.$emit('ok')
                    this.close()
                }else{
                    this.$message.warning(res.message)
                }
            })
        },
        handleCancel() {
            this.close()
        },
        close () {
            this.$emit('close');
            this.setCommandParamsKey = [];
            this.formModel = this.$options.data.call(this).formModel;
            this.commandKey = this.$options.data.call(this).commandKey;
            this.$refs.formModel.resetFields();
            this.visible = false;
            this.confirmLoading = false;
        },
        handleCommandChange(e) {
            this.commandKey = e
            this.$refs.formModel.resetFields();
        },
        changeSetParams(e) {
            this.setCommandParamsKey = e
        },
    }
}
</script>
<style scoped>
.ant-form >>> .ant-form-item .ant-input-number{
    width: 100%;
}
.ant-form >>> .ant-form-item .ant-form-item-label{
    line-height: unset;
}
.ant-form >>> .ant-input-number-affix .ant-input-number{
    width: calc(100% - 50px);
}
.ant-input-number-suffix{
    display: inline-block;
    width: 50px;
    text-align: left;
    padding-left: 3px;
}
.detail-list >>> .content{
    line-height: normal;
}
.ant-modal-root >>> .ant-modal-cust-warp .ant-modal{
    max-height: 1000px;
}
.form-item-series >>> .series-first .ant-select-selection {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.form-item-series >>> .series-last .ant-select-selection {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>